// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__wYRj2","col":"styles_col__2puTb"};